import { render, staticRenderFns } from "./Infoworks.vue?vue&type=template&id=2f567b9c&scoped=true"
import script from "./Infoworks.vue?vue&type=script&lang=js"
export * from "./Infoworks.vue?vue&type=script&lang=js"
import style0 from "./Infoworks.vue?vue&type=style&index=0&id=2f567b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f567b9c",
  null
  
)

export default component.exports